import styled from "styled-components";

function MensajeNoHayDatos({ mensaje }) {
  return <Mensaje>{mensaje}</Mensaje>;
}

const Mensaje = styled.p`
  width: 100%;
  height: 3rem;
  padding: 1rem;
  font-size: 15px;
  font-weight: 300;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  background: #a61f12;
  border-radius: 5px;
`;

export default MensajeNoHayDatos;
